export const GET_DIMENSIONS_OUTCOMES_WATCHER =
  "app/ReportsV2/WidgetListOutcomes/GET_DIMENSIONS_OUTCOMES_WATCHER"
export const GET_DIMENSIONS_OUTCOMES_SUCCESS =
  "app/ReportsV2/WidgetListOutcomes/GET_DIMENSIONS_OUTCOMES_SUCCESS"
export const GET_DIMENSIONS_OUTCOMES_FAILED =
  "app/ReportsV2/WidgetListOutcomes/GET_DIMENSIONS_OUTCOMES_FAILED"
